// Ghost buttons on the amber bar keep the bar's contrast in both themes.
export const BAR_BUTTON =
	"text-amber-950 hover:bg-white/50 hover:text-amber-950 dark:text-amber-950 dark:hover:bg-white/50 dark:hover:text-amber-950 data-[state=open]:bg-white/60"

export const BAR_ICON = "text-amber-900 dark:text-amber-900"
